import * as $ from "jquery";

export const initPasswordEye = (): void => {
    $(".ef-password-with-eye button").click((e: any) => {
        let button = e.currentTarget;
        let $input = $(button.parentElement).prev();
        let icon = button.firstChild;

        $input.attr('type', $input.is(':password') ? 'text' : 'password');
        if ($input.attr('type') === 'password') {
            $(icon).removeClass("fa-eye");
            $(icon).addClass("fa-eye-slash");
        }
        else{
            $(icon).removeClass("fa-eye-slash");
            $(icon).addClass("fa-eye");
        }
       
    }); 
}